<template>
  <div class="modal" :class="{ 'is-active': is_open }">
    <div class="modal-background" @click="close"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ getModalTitle() }}
        </p>
        <button class="delete" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <form @submit.prevent="save">
          <!-- Request Selection (only for new evaluations) -->
          <!-- <div class="field" v-if="!is_editing && !preselected_request_uuid">
            <label class="label">{{ $t("credit analysis request") }} *</label>
            <div class="control">
              <generic-dropdown
                :title="$t('select request')"
                :placeholder="$t('select a request')"
                :is_multiple="false"
                url="/credit-analysis/request/catalog"
                name_field="customer_name"
                value_field="uuid"
                :display_function="formatRequestDisplay"
                @selected="requestSelected"
                ref="request_dropdown"
              />
            </div>
          </div> -->

          <generic-uploader
            ref="generic_uploader"
            :idle_label="$t('drop sirc pdf here')"
            endpoint_url="/credit-analysis/evaluation/pdf"
            :allow_multiple="false"
            @error="error_uploading"
            @success="success_uploading"
          />

          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("customer name") }} *</label>
                <div class="control">
                  <input
                    type="text"
                    class="input"
                    v-model="form.customer_name"
                    :placeholder="$t('enter customer name')"
                    required
                  />
                </div>
              </div>
              <div class="field mb-0">
                <label class="label">{{ $t("dpi") }} *</label>
                <div class="control">
                  <input
                    type="text"
                    class="input"
                    v-model="form.dpi"
                    :placeholder="$t('enter dpi')"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("nit") }} *</label>
                <div class="control">
                  <input
                    type="text"
                    class="input"
                    v-model="form.nit"
                    :placeholder="$t('enter nit')"
                    required
                  />
                </div>
              </div>
              <div class="field mb-0">
                <label class="label">{{ $t("pagare number") }}</label>
                <div class="control">
                  <input
                    type="text"
                    class="input"
                    v-model="form.pagare_number"
                    :placeholder="$t('enter pagare number')"
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="
              show_wrong_customer_name_warning ||
              show_wrong_nit_warning ||
              show_wrong_dpi_warning ||
              show_wrong_pdf_warning
            "
            class="notification is-warning my-5"
          >
            <p class="mb-2" v-if="show_wrong_pdf_warning">
              <span class="has-text-weight-extrabold">{{
                $t(
                  "customer name not found in pdf, please check pdf, is the right sirc document?"
                )
              }}</span>
            </p>
            <p class="mb-2" v-if="show_wrong_customer_name_warning">
              {{
                $t(
                  "customer name from pdf does not match the entered customer name, please verify"
                )
              }}
            </p>
            <p class="mb-2" v-if="show_wrong_dpi_warning">
              {{
                $t("dpi from pdf does not match the entered dpi, please verify")
              }}
            </p>
            <p class="mb-2" v-if="show_wrong_nit_warning">
              {{
                $t("nit from pdf does not match the entered nit, please verify")
              }}
            </p>
          </div>

          <div class="columns">
            <div class="column">
              <label class="label">{{ $t("segment") }}</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="form.segment">
                    <option value="">{{ $t("select one") }}</option>
                    <option value="plus">{{ $t("plus") }}</option>
                    <option value="extra">{{ $t("extra") }}</option>
                    <option value="premium">{{ $t("premium") }}</option>
                    <option value="ultra">{{ $t("ultra") }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column">
              <generic-dropdown
                :title="$t('select ruleset')"
                :placeholder="$t('select a ruleset')"
                :is_multiple="true"
                url="/credit-analysis/ruleset/catalog"
                name_field="name"
                value_field="uuid"
                @selected="rulesetSelected"
                ref="ruleset_dropdown"
              />
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <!-- Income -->
              <label class="label">{{ $t("income") }}</label>
              <div class="control">
                <input
                  type="text"
                  class="input"
                  v-model="form.income"
                  :placeholder="$t('enter income')"
                />
              </div>
            </div>
            <div class="column">
              <!-- Email -->
              <label class="label">{{ $t("email") }}</label>
              <div class="control">
                <input
                  type="email"
                  class="input"
                  v-model="form.email"
                  :placeholder="$t('enter email')"
                />
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <!-- Phone Number -->
              <label class="label">{{ $t("phone number") }}</label>
              <div class="control">
                <input
                  type="text"
                  class="input"
                  v-model="form.phone_number"
                  :placeholder="$t('enter phone number')"
                />
              </div>
            </div>
            <div class="column"></div>
          </div>

          <div
            class="list my-5"
            v-if="selected_rulesets && selected_rulesets.length"
          >
            <div
              v-for="(ruleset, rsidx) in selected_rulesets"
              :key="rsidx"
              class="mb-5"
            >
              <div class="title is-5 mb-2">{{ ruleset.name }}</div>
              <div
                class="list-item mb-1"
                v-for="(rule, ridx) in ruleset.settings.rule_list"
                :key="ridx"
              >
                <span class="icon">
                  <i class="fa fa-clock-o has-text-warning"></i>
                </span>
                <span>{{ rule.name }}</span>
              </div>
            </div>
          </div>
          <div v-else class="notification is-warning my-5">
            <p>{{ $t("no rules selected yet") }}</p>
          </div>

          <!-- <div class="button is-primary is-rounded is-fullwidth mb-5">
            <span class="icon">
              <i class="fa fa-bolt"></i>
            </span>
            <span>{{ $t("run analysis") }}</span>
          </div> -->

          <!-- Selected Request Info (when preselected or selected) -->
          <!-- <div class="mb-6" v-if="selected_request">
            <h5 class="title is-5 mb-2">
              {{ selected_request.customer_name }}
            </h5>
            <div class="columns">
              <div class="column is-6">
                <div>
                  <span class="icon">
                    <i class="fa fa-file-text"></i>
                  </span>
                  <strong>{{ $t("pagare number") }}:</strong>
                  <span class="is-size-5 ml-3">
                    {{ selected_request.pagare_number }}</span
                  >
                </div>
              </div>
              <div class="column is-6">
                <div>
                  <span class="icon">
                    <i class="fa fa-id-card"></i>
                  </span>
                  <strong>{{ $t("dpi") }}:</strong>
                  <span class="is-size-5 ml-3">{{ selected_request.dpi }}</span>
                </div>
                <div>
                  <span class="icon">
                    <i class="fa fa-building"></i>
                  </span>
                  <strong>{{ $t("nit") }}:</strong>
                  <span class="is-size-5 ml-3">{{ selected_request.nit }}</span>
                </div>
              </div>
            </div>
          </div> -->

          <!-- Analysis Result -->
          <!-- <div class="field">
            <label class="label">{{ $t("analysis result") }}</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="form.analysis_result">
                  <option value="pending_review">
                    {{ $t("pending review") }}
                  </option>
                  <option value="approved">{{ $t("approved") }}</option>
                  <option value="rejected">{{ $t("rejected") }}</option>
                </select>
              </div>
            </div>
          </div> -->

          <!-- Score -->
          <!-- <div class="field">
            <label class="label">{{ $t("score") }}</label>
            <div class="control">
              <input
                type="number"
                class="input"
                v-model="form.score"
                :placeholder="$t('enter score 0-100')"
                min="0"
                max="100"
                step="0.1"
              />
            </div>
            <p class="help">{{ $t("optional score from 0 to 100") }}</p>
          </div> -->

          <!-- Comments -->
          <!-- <div class="field">
            <label class="label">{{ $t("evaluation comments") }}</label>
            <div class="control">
              <textarea
                class="textarea"
                v-model="form.comments"
                :placeholder="$t('enter evaluation comments')"
                rows="4"
              ></textarea>
            </div>
          </div> -->

          <!-- PDF Upload Section -->
          <!-- <div class="field" v-if="mode === 'upload' || is_editing">
            <label class="label">{{ $t("upload pdf") }}</label>
            <div class="file has-name is-fullwidth">
              <label class="file-label">
                <input
                  class="file-input"
                  type="file"
                  name="pdf"
                  @change="onFileSelected"
                  accept=".pdf"
                  ref="file_input"
                />
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fa fa-upload"></i>
                  </span>
                  <span class="file-label">{{ $t("choose pdf file") }}</span>
                </span>
                <span class="file-name">
                  {{
                    selected_file ? selected_file.name : $t("no file selected")
                  }}
                </span>
              </label>
            </div>
            <p class="help">{{ $t("pdf files only, max 10MB") }}</p>
          </div> -->

          <!-- Current PDF (if exists) -->
          <!-- <div class="field" v-if="form.pdf_file_path">
            <label class="label">{{ $t("current pdf") }}</label>
            <div class="control">
              <a
                :href="form.pdf_file_path"
                target="_blank"
                class="button is-info"
              >
                <span class="icon">
                  <i class="fa fa-file-pdf"></i>
                </span>
                <span>{{ $t("view current pdf") }}</span>
              </a>
            </div>
          </div> -->

          <!-- Status -->
          <!-- <div class="field">
            <label class="label">{{ $t("evaluation status") }}</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="form.status">
                  <option value="draft">{{ $t("draft") }}</option>
                  <option value="completed">{{ $t("completed") }}</option>
                  <option value="archived">{{ $t("archived") }}</option>
                </select>
              </div>
            </div>
          </div> -->
        </form>
      </section>
      <footer class="modal-card-foot">
        <button
          class="button is-success is-rounded"
          @click="save"
          :disabled="is_loading"
        >
          <span class="icon" v-if="is_loading">
            <i class="fa fa-spinner fa-spin"></i>
          </span>
          <span class="icon" v-else>
            <i class="fa fa-bolt"></i>
          </span>
          <span>{{ $t("evaluate") }}</span>
          <!-- <span>{{ getSaveButtonText() }}</span> -->
        </button>
        <button
          class="button is-danger is-rounded ml-2"
          @click="deny"
          v-show="form.request_uuid"
        >
          <span class="icon">
            <i class="fa fa-ban"></i>
          </span>
          <span>{{ $t("deny") }}</span>
          <!-- <span>{{ getSaveButtonText() }}</span> -->
        </button>
        <button class="button is-rounded ml-2" @click="close">
          <span class="icon">
            <i class="fa fa-times"></i>
          </span>
          <span>{{ $t("cancel") }}</span>
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import {
  get,
  post,
  put,
  success_message,
  error_message,
  warning_message,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";

export default {
  name: "CreditAnalysisEvaluationModal",
  components: { GenericDropdown, GenericUploader },
  data() {
    return {
      is_open: false,
      is_editing: false,
      is_loading: false,
      uuid: null,
      mode: "normal", // 'normal', 'upload', 'complete'
      preselected_request_uuid: null,
      selected_request: null,
      selected_file: null,
      selected_rulesets: [],
      form: {
        request_uuid: "",
        score: null,
        comments: "",
        status: "draft",
        pdf_file_path: "",
        //
        customer_name: "",
        nit: "",
        dpi: "",
        pagare_number: "",
      },
      show_wrong_customer_name_warning: false,
      show_wrong_nit_warning: false,
      show_wrong_dpi_warning: false,
      show_wrong_pdf_warning: false,
    };
  },
  methods: {
    open(uuid = null, request_uuid = null, mode = "normal") {
      //   console.log("Opening evaluation modal", { uuid, request_uuid, mode });
      this.uuid = uuid;
      this.is_editing = !!uuid;
      this.mode = mode;
      this.preselected_request_uuid = request_uuid;
      this.is_open = true;

      if (this.is_editing) {
        this.loadEvaluation();
      } else {
        this.resetForm();
        if (request_uuid) {
          this.loadRequestInfo(request_uuid);
        }
      }
    },
    close() {
      this.is_open = false;
      this.resetForm();
      this.selected_request = null;
      this.selected_file = null;
      this.mode = "normal";
      this.preselected_request_uuid = null;
    },
    resetForm() {
      this.form = {
        request_uuid: this.preselected_request_uuid || "",
        score: null,
        comments: "",
        status: "draft",
        pdf_file_path: "",
        //
        customer_name: "",
        nit: "",
        dpi: "",
        pagare_number: "",
      };
      this.show_wrong_customer_name_warning = false;
      this.show_wrong_nit_warning = false;
      this.show_wrong_dpi_warning = false;
      this.show_wrong_pdf_warning = false;
      this.$refs.generic_uploader.clear();
      this.selected_rulesets = [];
      this.$refs.ruleset_dropdown.clear();
    },
    loadEvaluation() {
      this.is_loading = true;

      get("/credit-analysis/evaluation", { uuid: this.uuid })
        .then((response) => {
          const data = response.data;
          this.form = {
            request_uuid: data.request_uuid || "",
            score: data.score || null,
            comments: data.comments || "",
            status: data.status || "draft",
            pdf_file_path: data.pdf_file_path || "",
            //
            customer_name: data.customer_name || "",
            nit: data.nit || "",
            dpi: data.dpi || "",
            pagare_number: data.pagare_number || "",
            email: data.email || "",
            phone_number: data.phone_number || "",
          };

          if (data.request) {
            this.selected_request = data.request;
          }
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    loadRequestInfo(request_uuid) {
      get("/credit-analysis/request", { uuid: request_uuid })
        .then((response) => {
          this.selected_request = response;
          this.form.request_uuid = request_uuid;
          //
          this.form.customer_name = response.customer_name || "";
          this.form.nit = response.nit || "";
          this.form.dpi = response.dpi || "";
          this.form.pagare_number = response.pagare_number || "";
          if (response.settings && response.settings.segment)
            this.form.segment = response.settings.segment;
          if (response.settings && response.settings.income)
            this.form.income = response.settings.income;
          if (response.settings && response.settings.phone_number)
            this.form.phone_number = response.settings.phone_number;
          if (response.settings && response.settings.email)
            this.form.email = response.settings.email;
        })
        .catch((error) => {
          error_message(error);
        });
    },
    requestSelected(request) {
      this.selected_request = request;
      this.form.request_uuid = request.uuid;
    },
    onFileSelected(event) {
      const file = event.target.files[0];
      if (file) {
        if (file.type !== "application/pdf") {
          error_message(this.$t("only pdf files are allowed"));
          event.target.value = "";
          return;
        }

        if (file.size > 10 * 1024 * 1024) {
          // 10MB
          error_message(this.$t("file size must be less than 10MB"));
          event.target.value = "";
          return;
        }

        this.selected_file = file;
      }
    },
    async save() {
      // if (!this.form.request_uuid) {
      //   error_message(this.$t("please select a request"));
      //   return;
      // }

      this.is_loading = true;

      try {
        let evaluation_uuid = this.uuid;

        if (!this.form.pdf_file) {
          error_message(this.$t("please upload a pdf file"));
          return;
        }
        if (!this.selected_rulesets || !this.selected_rulesets.length) {
          error_message(this.$t("please select at least one ruleset"));
          return;
        }

        // First, save/update the evaluation
        const data = {
          request_uuid: this.form.request_uuid,
          score: this.form.score,
          comments: this.form.comments,
          status: this.form.status,
          //
          customer_name: this.form.customer_name,
          nit: this.form.nit,
          dpi: this.form.dpi,
          pagare_number: this.form.pagare_number,
          pdf_file: this.form.pdf_file,
          settings: {
            rulesets: this.selected_rulesets.map((r) => r.ruleset_id),
            segment: this.form.segment,
            income: this.form.income,
            email: this.form.email,
            phone_number: this.form.phone_number,
          },
        };

        if (this.is_editing) {
          data.uuid = this.uuid;
          await post("/credit-analysis/evaluation", data);
        } else {
          const response = await put("/credit-analysis/evaluation", data);
          evaluation_uuid = response.uuid;
        }

        // If there's a file to upload, upload it
        if (this.selected_file && evaluation_uuid) {
          await this.uploadFile(evaluation_uuid);
        }

        success_message(this.$t("evaluation saved successfully"));
        this.$emit("saved");
        this.close();
      } catch (error) {
        console.error("Error saving evaluation:", error);
        error_message(error);
      } finally {
        this.is_loading = false;
      }
    },
    async uploadFile(evaluation_uuid) {
      const formData = new FormData();
      formData.append("pdf", this.selected_file);
      formData.append("evaluation_uuid", evaluation_uuid);

      const response = await fetch("/credit-analysis/evaluation/upload", {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${this.$store.getters.token}`, // Adjust based on auth system
        },
      });

      if (!response.ok) {
        throw new Error(this.$t("pdf upload failed"));
      }

      const result = await response.json();
      this.form.pdf_file_path = result.file_path;
    },
    formatRequestDisplay(request) {
      return `${request.customer_name} - ${request.pagare_number}`;
    },
    getModalTitle() {
      if (this.mode === "upload") {
        return this.$t("upload pdf");
      } else if (this.mode === "complete") {
        return this.$t("complete evaluation");
      } else if (this.is_editing) {
        return this.$t("edit evaluation");
      } else {
        return this.$t("new evaluation");
      }
    },
    getSaveButtonText() {
      if (this.mode === "upload") {
        return this.$t("upload");
      } else if (this.mode === "complete") {
        return this.$t("complete");
      } else {
        return this.$t("save");
      }
    },
    error_uploading(error) {
      console.error(error);
      error_message(error);
    },
    success_uploading(response) {
      let v = this;
      // v.$refs.generic_uploader.clear();
      let rspnse = JSON.parse(response.serverId);
      // let data = {
      //   file_id: rspnse.file.file_id,
      //   final_name: rspnse.final_name,
      //   meta: rspnse.file.settings,
      //   original_name: rspnse.file.name,
      // };

      //   console.log("data", data);
      v.form.pdf_file = rspnse.file;
      if (rspnse.customer_name) {
        if (!v.form.customer_name) v.form.customer_name = rspnse.customer_name;
        else {
          if (v.form.customer_name != rspnse.customer_name) {
            v.show_wrong_customer_name_warning = true;
            // warning_message(
            //   v.$t("customer name from pdf does not match the entered customer name, please verify")
            // );
          }
        }
      } else {
        v.$refs.generic_uploader.clear();
        v.show_wrong_pdf_warning = true;
        // warning_message(
        //   v.$t(
        //     "customer name not found in pdf, please check pdf, is the right sirc document?"
        //   )
        // );
      }
      if (rspnse.cui) {
        if (!v.form.dpi) v.form.dpi = rspnse.cui;
        else {
          if (v.form.dpi != rspnse.cui) {
            v.show_wrong_dpi_warning = true;
            // warning_message(
            //   v.$t("dpi from pdf does not match the entered dpi, please verify")
            // );
          }
        }
      }
      if (rspnse.nit) {
        if (!v.form.nit) v.form.nit = rspnse.nit.replace(/-/g, "");
        else {
          if (v.form.nit != rspnse.nit.replace(/-/g, "")) {
            v.show_wrong_nit_warning = true;
            // warning_message(
            //   v.$t("nit from pdf does not match the entered nit, please verify")
            // );
          }
        }
      }
    },
    rulesetSelected(ruleset) {
      if (ruleset) {
        if (Array.isArray(ruleset)) this.selected_rulesets = ruleset;
        else this.selected_rulesets = [ruleset];
      }
    },
    deny() {
      this.$emit("deny_request", this.form.request_uuid);
      this.close();
    },
  },
};
</script>

<style scoped>
.modal-card {
  width: 90%;
  max-width: 700px;
  max-height: 90vh;
}

.modal-card-body {
  max-height: 70vh;
  overflow-y: auto;
}

.help {
  font-size: 0.875rem;
  color: #888;
}

.field {
  margin-bottom: 1.5rem;
}

.box {
  margin-bottom: 1.5rem;
  /* background-color: #f8f9fa; */
}
</style>
